import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { ImportacaoLeadResponse } from "../interfaces/ImportacaoLeads";

export const importarLeadsPlanilhaService = async (
  file: File,
  etiquetaIds: number[] = []
) => {
  const Token = validateToken();

  if (!Token) {
    throw new Error("Token inválido. Usuário não autenticado.");
  }

  const URL = `${Globais.DOMINIOBACK}/lead/importar-planilha`;
  const formData = new FormData();

  formData.append("file", file);

  if (etiquetaIds.length > 0) {
    formData.append("etiquetaIds", JSON.stringify(etiquetaIds));
  }

  const response = await axios.post<ImportacaoLeadResponse>(URL, formData, {
    headers: {
      Authorization: Token.AuthStr,
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
